import { Component, Input, OnInit } from '@angular/core';
import { LoaderService } from '../loader/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  public IsLoading = false;
  @Input() IsInLoading = false;
  constructor(
    private loaderService: LoaderService
  ) { }

  ngOnInit() {
    this.loaderService.LoadSubject.subscribe(toDisplay => {
      this.IsLoading = toDisplay;
    });
    this.loaderService.Initialize();
  }

}
